import React from "react";

const services = [
	"Broadband and Fiber Deployment",
	"VoIP & PBX Systems",
	"Network Design & Installation",
	"ICT Infrastructure Management",
	"Cloud and Data Services",
];

const Services = () => (
	<section id="services" className="bg-gray-50 py-16 px-6">
		<div className="max-w-5xl mx-auto">
			<h3 className="text-3xl font-bold text-[#031B4E] mb-8 text-center">
				Our Services
			</h3>
			<ul className="grid md:grid-cols-2 gap-6">
				{services.map((s, i) => (
					<li
						key={i}
						className="bg-white p-6 border-l-4 border-[#00BFFF] shadow-md"
					>
						{s}
					</li>
				))}
			</ul>
		</div>
	</section>
);

export default Services;
